import React from "react";
import { spring, interpolate } from "remotion";

interface OutroProps {
  keywords: string[];
  frame: number;
  fps: number;
}

export const GeometricLiquidOutro: React.FC<OutroProps> = ({
  keywords,
  frame,
  fps,
}) => {
  // Pulsing follow button logic
  const pulse = Math.sin((frame / fps) * Math.PI * 2) * 0.05;
  const buttonScale = 1 + pulse;

  const contentOpacity = interpolate(frame, [0, 10], [0, 1], {
    extrapolateLeft: "clamp",
    extrapolateRight: "clamp",
  });

  const contentTranslateY = spring({
    frame,
    fps,
    from: 30,
    to: 0,
    config: { damping: 12, mass: 0.6 },
  });

  return (
    <div
      style={{
        width: "100%",
        padding: "50px",
        background: "rgba(15, 23, 42, 0.7)",
        backdropFilter: "blur(20px)",
        WebkitBackdropFilter: "blur(20px)",
        border: "1px solid rgba(190, 242, 100, 0.3)", // Electric Lime border
        borderRadius: "32px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        gap: "32px",
        opacity: contentOpacity,
        transform: `translateY(${contentTranslateY}px)`,
        boxShadow: "0 12px 64px rgba(0, 0, 0, 0.5)",
      }}
    >
      <div
        style={{
          fontFamily: "'Space Grotesk', sans-serif",
          fontSize: "14px",
          fontWeight: 600,
          color: "#22d3ee", // Neon Cyan
          letterSpacing: "4px",
          textTransform: "uppercase",
        }}
      >
        // Terminal.End
      </div>

      <h2
        style={{
          fontFamily: "'Space Grotesk', sans-serif",
          fontSize: "48px",
          fontWeight: 700,
          lineHeight: 1.1,
          color: "#ffffff",
          margin: 0,
        }}
      >
        Upgrade Your Intelligence
      </h2>

      <p
        style={{
          fontFamily: "'Inter', sans-serif",
          fontSize: "20px",
          color: "rgba(255, 255, 255, 0.7)",
          margin: 0,
          maxWidth: "80%",
        }}
      >
        The future is being built today. Don't fall behind.
      </p>

      {/* Pulsing CTA Action Button */}
      <div
        style={{
          transform: `scale(${buttonScale})`,
          width: "100%",
          maxWidth: "380px",
          background: "linear-gradient(135deg, #bef264, #22d3ee)", // Lime to Cyan
          borderRadius: "12px",
          padding: "24px 0",
          boxShadow: "0 0 30px rgba(190, 242, 100, 0.4)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "10px",
        }}
      >
        <span
          style={{
            fontFamily: "'Space Grotesk', sans-serif",
            fontWeight: 700,
            fontSize: "24px",
            color: "#0f172a",
            textTransform: "uppercase",
            letterSpacing: "2px",
          }}
        >
          Initialize Follow
        </span>
      </div>

      <div
        style={{
          fontFamily: "'Space Grotesk', sans-serif",
          fontSize: "22px",
          fontWeight: 700,
          color: "#bef264",
          letterSpacing: "1px",
        }}
      >
        {keywords?.[0] ? `@${keywords[0].replace(/\s+/g, '')}` : "@FutureTech"}
      </div>
    </div>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
